import { render, staticRenderFns } from "./other-expense-ledger.vue?vue&type=template&id=86bea586&"
import script from "./other-expense-ledger.js?vue&type=script&lang=js&"
export * from "./other-expense-ledger.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports